import { useEffect, useState } from "react";

import { AvatarFallback, Avatar as UpsAvatar } from "@upstageai/ui";

import useAuth from "../../hooks/useAuth";
import { getRandomValue } from "../../utils/random";

export default function Avatar() {
  const [userInitial, setUserInitial] = useState("");
  const { logout } = useAuth();

  useEffect(() => {
    const randomChar = String.fromCharCode(
      Math.floor(getRandomValue() * 26) + 65,
    ); // A부터 Z까지 랜덤 문자 생성
    setUserInitial(randomChar);
  }, []);

  // TODO: 컬러 랜덤셋(단, 개인 사용자는 컬러 고정)을 위해 추후에 색상 더 추가 필요
  // XXX: 한가지 컬러만 사용하고 있는데, 멀티 컬러 or 개선 방안 논의 필요 (w. @HSeo-git)
  const colorList = [
    "bg-accent-violet-background text-accent-violet-foreground",
  ];

  const avatarColorClassName = colorList[0];

  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault(); // 기본 이벤트 방지
    logout();
    window.location.href = "/login";
  };

  return (
    <UpsAvatar className="hover:cursor-pointer" onClick={handleClick}>
      <AvatarFallback className={avatarColorClassName}>
        {userInitial}
      </AvatarFallback>
    </UpsAvatar>
  );
}
